module.exports = __webpack_public_path__ + "img/eurodycar.cec335e6.webp";